export default __webpack_public_path__ + "static/media/Vector.dded2a4a.svg";